// extracted by mini-css-extract-plugin
export default {"counter":"counter-particle_counter__q+xrm","grow":"counter-particle_grow__rX453"};